import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './Out-Of-Application/login/login.component';
import { PrivacyNoticeComponent } from './Inside-Of-Application/privacy-notice/privacy-notice.component';
import { APP_BASE_HREF } from '@angular/common';
import { AuthGuardService as RoleGuard } from './CommonService/auth-guard.service';
import { LogoutComponent } from './Out-Of-Application/logout/logout.component';
import { PageNotFoundComponent } from './Out-Of-Application/page-not-found/page-not-found.component';
import { HomeComponent } from './Inside-Of-Application/home/home.component';
import { CreateGTCRequisitionComponent } from './Inside-Of-Application/Requisition/create-gtcrequisition/create-gtcrequisition.component';
import { AllRequisitionViewComponent } from './Inside-Of-Application/Requisition/all-requisition-view/all-requisition-view.component';
import { RoleAssignmentComponent } from './Inside-Of-Application/role-assignment/role-assignment.component';
import { TQApprovalComponent } from './Inside-Of-Application/tqapproval/tqapproval.component';
import { SpecialApprovalComponent } from './Inside-Of-Application/special-approval/special-approval.component';
import { ReportsComponent } from './Inside-Of-Application/reports/reports.component';


export const routes: Routes = [
  {
    path: 'home', component: HomeComponent,
    children: [

      {
        path:'createRequistion',component: CreateGTCRequisitionComponent , canActivate: [RoleGuard],
        data:{

          expectedRole: ['Admin' ,'TQApprover','EngTeam','TQLeader']
        }
      },
      {
        path:'createRequistion/edit/:ID',component: CreateGTCRequisitionComponent , canActivate: [RoleGuard],
        data:{

          expectedRole: ['Admin' ,'TQApprover','EngTeam','TQLeader']
        }
      },
      {
        path:'createRequistion/new/:ID/:Value',component: CreateGTCRequisitionComponent , canActivate: [RoleGuard],
        data:{

          expectedRole: ['Admin' ,'TQApprover','EngTeam','TQLeader']
        }
      },
      {
        path:'AllRequisition',component: AllRequisitionViewComponent , canActivate: [RoleGuard],
        data:{

          expectedRole: ['Admin' ,'TQApprover','TQLeader']
        }
      },
      {
        path:'MyRequisition/:ID',component: AllRequisitionViewComponent , canActivate: [RoleGuard],
        data:{

          expectedRole: ['Admin' ,'EngTeam']
        }
      },
      {
        path:'ApprovedRequistion/:ID',component: AllRequisitionViewComponent , canActivate: [RoleGuard],
        data:{

          expectedRole: ['Admin' ,'TQApprover','TQLeader']
        }
      },
      {
        path: 'RoleAssign', component: RoleAssignmentComponent,
        canActivate: [RoleGuard],
        data: {
          expectedRole: ['Admin']
        }
      },
      {
        path: 'TQTeamView/:ID', component: TQApprovalComponent,
        canActivate: [RoleGuard],
        data: {
          expectedRole: ['Admin' ,'TQApprover']
        }
      },
      {
        path: 'TQLeaderView/:ID', component: TQApprovalComponent,
        canActivate: [RoleGuard],
        data: {
          expectedRole: ['Admin','TQLeader']
        }
      },

      {
        path: 'TQLeaderDetailsView/:ReqId', component: SpecialApprovalComponent,
        canActivate: [RoleGuard],
        data: {
          expectedRole: ['Admin' ,'TQLeader']
        }
      },
      
      {
        path: 'Reports', component: ReportsComponent,
        canActivate: [RoleGuard],
        data: {
          expectedRole: ['Admin' ,'TQApprover','EngTeam','TQLeader']
        }
      },

    ]
  },
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'privacyNotice', component: PrivacyNoticeComponent },
  { path: 'ref/:Path', component: LoginComponent },
  { path: 'logout', component: LogoutComponent },
  { path: 'unauthorize', component: PageNotFoundComponent },
  { path: 'badrequest', component: PageNotFoundComponent },
  { path: 'pagenotfound', component: PageNotFoundComponent },
  { path: 'sessionexpired', component: PageNotFoundComponent },
  { path: 'error/:ID', component: PageNotFoundComponent },

  { path: '**', redirectTo: 'pagenotfound' },



]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
  // providers: [{ provide: APP_BASE_HREF, useValue: '/' }, RoleGuard]
})
export class AppRoutingModule {

 
 }
